import Vue from 'vue'
import Vuex from 'vuex'
import { getField, updateField } from 'vuex-map-fields'
import formModel from './models/formModel'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loader: false, // Bandera para activar el "loader"
    landingCounter: 1, // Contador para el formulario
    contadorDatos: 0, // Contador para la primer parte del formulario
    coverageFlag: false, //Flag para determinar la zona de covertura
    pagoTarjetaMaximoFlag: false, // Flag para saber si ya no tiene permitidos intentos para pago con tarjeta.
    thanksModal: false, // Activador para el modal de agradecimiento de feedback
    servicioSolicitado: false, // Bandera para el modal servicioSolicitado
    conoceMasModal: false, // Activador para el modal de conoce más
    otherTipModal: false,
    completeLitersModal: false, // Activador para el modal de litros completos
    message: '', // Mensaje del snackbar
    showMessage: false, // v-model del snackbar
    seguirServicioModal: false, // Flag del modal seguir servicio
    seguirServicioNumberUuid: '', // Numero de telefono que mandamos a sigue tu servicio para cargar los datos.
    coordenadasCenterMap: { //Coordenadas por default para centrar el map
      lat: 19.4269903,
      lng: -99.1676463,
    },
    coordenadasSigueServicio: { // Coordenadas para Sigue tu servicio
      coordenadasServicio: {
        lat: 19.42699,
        lng: -99.167646,
      },
      coordenadasProveedor: {
        lat: 19.42660,
        lng: -99.16761,
      },
    },    
    //Modelo del formulario
    ...formModel,
  },
  getters: {
    getField
  },
  mutations: {
    updateField
  },
  actions: {},
  modules: {
  }
})
